// extracted by mini-css-extract-plugin
module.exports = {"productInput":"InAppPurchaseRecord_productInput__1Q6pY","table":"InAppPurchaseRecord_table__265g3"};